import {
  red,
  purple,
  indigo,
  blue,
  cyan,
  teal,
  green,
  orange,
  deepOrange,
  brown,
  blueGrey
} from "material-ui/colors";

const colors = [
  red[600],
  red[700],
  red[800],
  red[900],
  purple[500],
  purple[600],
  purple[700],
  purple[800],
  purple[900],
  indigo[500],
  indigo[600],
  indigo[700],
  indigo[800],
  blue[500],
  blue[600],
  blue[700],
  blue[800],
  blue[900],
  cyan[700],
  cyan[800],
  cyan[900],
  teal[500],
  teal[600],
  teal[700],
  teal[800],
  teal[900],
  green[600],
  green[700],
  green[800],
  green[900],
  orange[800],
  orange[900],
  deepOrange[700],
  deepOrange[800],
  deepOrange[900],
  brown[500],
  brown[600],
  brown[700],
  brown[800],
  blueGrey[500],
  blueGrey[600],
  blueGrey[700],
  blueGrey[800]
];

// https://stackoverflow.com/a/22429679
export default function avatarColor(name) {
  let val = 0; // can be any seed number
  for (let i = 0, l = name.length; i < l; i++) {
    val ^= name.charCodeAt(i);
    val += (val << 1) + (val << 4) + (val << 7) + (val << 8) + (val << 24);
  }
  const colorIndex = (val >>> 0) % colors.length;
  return colors[colorIndex];
}



// WEBPACK FOOTER //
// ./src/helpers/avatarColor.js